export default __webpack_public_path__ + "static/summer_containers73-932579ca631b4cdc428f8a2b2f11adb6.webp";